const LoadingSpinner = ({ size = 'default', className = '', withOverlay = false }) => {
    const sizeStyles = {
        small: { width: '16px', height: '16px' },
        default: { width: '40px', height: '40px' },
        large: { width: '64px', height: '64px' }
    };
    
    const spinnerClass = size === 'small' ? 'spinner spinner-small' : size === 'large' ? 'spinner spinner-large' : 'spinner';
    
    const spinnerElement = (
        <div className={`flex justify-center items-center ${className}`}>
            <div className={spinnerClass} style={sizeStyles[size] || sizeStyles.default}></div>
        </div>
    );

    if (withOverlay) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-black/10 backdrop-blur-sm z-[9999]">
                {spinnerElement}
            </div>
        );
    }

    return spinnerElement;
}
export default LoadingSpinner;
